import { ApplicationType } from "@/store/slices/types/applicationFormSlice";

export const typeOfSaleList = {
  DEALER_SALE: "Authorised seller",
  EV_SALE: "Authorised electric vehicle seller",
  PRIVATE_SALE: "Private sale",
  MID_TERM_REFINANCE: "Mid-term refinance",
  BALLOON_RESIDUAL_REFINANCE: "Balloon / Residual Refinance",
  SALE_BUYBACK_EQUITY: "Sale & buyback / Equity",
};

export const VITE_UNAUTHORIZED_REDIRECT = import.meta.env.VITE_UNAUTHORIZED_REDIRECT;

export const VITE_ALLOWED_LENDER_LIST = import.meta.env.VITE_ALLOWED_LENDER_LIST || [];

export const VITE_INTERCOM_APP_ID = import.meta.env.VITE_INTERCOM_APP_ID;

export const VITE_ANNOUNCE_KIT_WIDGET = import.meta.env.VITE_ANNOUNCE_KIT_WIDGET;

// Document Template Editor environment variables
export const VITE_CKEDITOR_LICENSE_KEY = import.meta.env.VITE_CKEDITOR_LICENSE_KEY || "";
export const VITE_CKEDITOR_CLOUD_SERVICES_TOKEN_URL = import.meta.env.VITE_CKEDITOR_CLOUD_SERVICES_TOKEN_URL || "";
export const VITE_CKEDITOR_CLOUD_SERVICES_WEBSOCKET_URL =
  import.meta.env.VITE_CKEDITOR_CLOUD_SERVICES_WEBSOCKET_URL || "";

export const assetTypes = {
  MOTOR_VEHICLE_UNDER_4_5_TONNES: "Motor Vehicle (<4.5 tonnes)",
  COMMERCIAL_SMALL_MEDIUM_LESS_THAN_12_TONNES: "Commercial (Small to Medium) Vehicles (<12 Tonnes)",
  COMMERCIAL_HEAVY_VEHICLE_GREATER_THAN_12_TONNES: "Commercial (Heavy) Vehicles (>12 Tonnes)",
};

export const productTypes = ["Standard", "Low doc", "Light doc", "Full doc", "Adverse"];

export const ADDRESS_STATUS_TYPE = {
  CURRENT: "current",
  PREVIOUS: "previous",
};

export const AddressStatusList = ["current", "previous"];

export const stateAbbreviationList = ["ACT", "NSW", "NT", "QLD", "TAS", "VIC", "WA"];

export const stateList = [
  "Australian Capital Territory",
  "New South Wales",
  "Northern Territory",
  "Queensland",
  "Tasmania",
  "Victoria",
  "Western Australia",
  "South Australia",
];

export const getAbbreviationState = {
  "Australian Capital Territory": "ACT",
  "New South Wales": "NSW",
  "Northern Territory": "NT",
  Queensland: "QLD",
  Tasmania: "TAS",
  Victoria: "VIC",
  "Western Australia": "WA",
  "South Australia": "SA",
};

export const streetTypeList = [
  "Access",
  "Alley",
  "Alleyway",
  "Amble",
  "Anchorage",
  "Approach",
  "Arcade",
  "Artery",
  "Avenue",
  "Bank",
  "Basin",
  "Beach",
  "Bend",
  "Block",
  "Boulevard",
  "Brace",
  "Brae",
  "Break",
  "Bridge",
  "Broadway",
  "Brow",
  "Bypass",
  "Byway",
  "Causeway",
  "Centre",
  "Centreway",
  "Chase",
  "Circle",
  "Circlet",
  "Circuit",
  "Circus",
  "Close",
  "Colonnade",
  "Common",
  "Concourse",
  "Copse",
  "Corner",
  "Corso",
  "Court",
  "Courtyard",
  "Cove",
  "Crescent",
  "Crossing",
  "Crossroad",
  "Crossway",
  "Cruiseway",
  "Cul-de-sac",
  "Cutting",
  "Dale",
  "Dell",
  "Deviation",
  "Dip",
  "Distributor",
  "Drive",
  "Driveway",
  "Edge",
  "Elbow",
  "End",
  "Entrance",
  "Esplanade",
  "Estate",
  "Expressway",
  "Extension",
  "Fairway",
  "FireTrail",
  "Flat",
  "Follow",
  "Footway",
  "Foreshore",
  "Formation",
  "Freeway",
  "Front",
  "Frontage",
  "Gap",
  "Garden",
  "Gardens",
  "Gate",
  "Gates",
  "Glade",
  "Glen",
  "Grange",
  "Green",
  "Ground",
  "Grove",
  "Gully",
  "Heights",
  "Highroad",
  "Highway",
  "Hill",
  "Interchange",
  "Intersection",
  "Junction",
  "Key",
  "Landing",
  "Lane",
  "Laneway",
  "Lees",
  "Line",
  "Link",
  "Little",
  "Lookout",
  "Loop",
  "Lower",
  "Mall",
  "Meander",
  "Mew",
  "Mews",
  "Motorway",
  "Mount",
  "Nook",
  "Outlook",
  "Parade",
  "Park",
  "Parklands",
  "Parkway",
  "Part",
  "Pass",
  "Path",
  "Piazza",
  "Place",
  "Plateau",
  "Plaza",
  "Pocket",
  "Point",
  "Port",
  "Promenade",
  "Quad",
  "Quadrangle",
  "Quadrant",
  "Quay",
  "Quays",
  "Ramble",
  "Ramp",
  "Range",
  "Reach",
  "Reserve",
  "Rest",
  "Retreat",
  "Ride",
  "Ridge",
  "Ridgeway",
  "Ring",
  "Rise",
  "River",
  "Riverway",
  "Riviera",
  "Road",
  "Roads",
  "Roadside",
  "Roadway",
  "Ronde",
  "Rosebowl",
  "Rotary",
  "Round",
  "Route",
  "Row",
  "Rue",
  "Run",
  "Siding",
  "Slope",
  "Sound",
  "Spur",
  "Square",
  "Stairs",
  "StateHighway",
  "Steps",
  "Street",
  "Strip",
  "Terrace",
  "Thoroughfare",
  "Tollway",
  "Top",
  "Tor",
  "Towers",
  "Track",
  "Trail",
  "Trailer",
  "Triangle",
  "Trunkway",
  "TURN",
  "Underpass",
  "Upper",
  "Vale",
  "Viaduct",
  "View",
  "Vista",
  "Wade",
  "Walk",
  "Walkway",
  "Way",
  "Wharf",
  "Wynd",
  "Yard",
];

export const livingArrangementsTypes = {
  PROPERTY_OWNER: "Property owner",
  RENTING: "Renting",
  BOARDING: "Boarding",
  LIVING_WITH_PARENTS: "Living w/ parents",
};

export const dollarStringOptions: Intl.NumberFormatOptions = {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
};

export const criteriaTypes = ["No deposit", "No property"];

export const productLenderFilterKey = "productLenderFilters";

export const commercialLenderList = [
  "AFS",
  "AMMF",
  "Angle Finance",
  "ANZ",
  "Azora Asset Finance",
  "Branded",
  "Capital Finance",
  "Dynamoney",
  "Finance One",
  "Flexi",
  "Group & General Finance",
  "GRENKE",
  "Liberty",
  "Macquarie",
  "Metro",
  "Pepper",
  "Plenti",
  "resimac",
  "ScotPac",
  "Selfco",
  "Shift",
  "Westpac",
  "Volkswagen Financial Services",
];

export const consumerLenderList = [
  "Affordable Car Loans",
  "Alex Bank",
  "AMMF",
  "Australian Premier Finance",
  "Autopay",
  "Branded",
  "Car Start",
  "Finance One",
  "FirstMac",
  // "Gedda Money",
  "Greenlight",
  "Latitude",
  "Liberty",
  "Macquarie",
  "Money3",
  "MoneyPlace",
  "NOW",
  "Pepper",
  "Plenti",
  "Salt & Lime",
  "WISR",
];

export const additionalManualQuoteLenderList = [
  "ALI Group",
  "AFS",
  "ANZ",
  "Bank of Melbourne",
  "Bank SA",
  "Bizcap",
  "BoQ",
  "Banjo",
  "Capify",
  "CBA",
  "CFI",
  "Capital Finance",
  "Earlypay",
  "Gamma Duo",
  "Judo",
  "Lumi",
  "Maple",
  "Medfin",
  "Metro",
  "MoneyMe",
  "MoneyMe Autopay",
  "Moneytech",
  "Morris Finance",
  "Moula",
  "Mulitpli",
  "NAB Asset Finance",
  "Orix",
  "Propsa",
  "Resimac",
  "RACV",
  "Rapid Loans",
  "Scotpac",
  "Selfco",
  "Shift",
  "Society One",
  "St George",
  "Veya Money",
  "Westpac - EF",
];

export const personalLoanLenderList = [
  "Alex Bank",
  "Latitude",
  "Money3",
  // "MoneyPlace",
  "NOW",
  "Plenti",
  "WISR",
];

export const PersonalLoanPurposeTypes = [
  "Vehicle",
  "Debt Consolidation",
  "Home Improvements",
  "Medical & Dental",
  "Household Furnishings",
  "Education",
  "Travel",
  "Wedding",
  "Mortgage Cost Funding",
  "Other Personal Use",
];

export const BusinessLoanPurposeTypes = ["Business Expansion", "Equipment Upgrade", "Stock", "Other"];

export const getLoanPurposeTypes = {
  [ApplicationType.Personal]: PersonalLoanPurposeTypes,
  [ApplicationType.Business]: BusinessLoanPurposeTypes,
};

export const consumerFinanceCriteriaFilterList = [
  "ageOfAsset",
  "ageOfAssetAtEnd",
  "assetType",
  "dateOfBirth",
  "deposit",
  "employmentType",
  "livingArrangements",
  "loanAmount",
  "score",
  "timeOfEmployment",
  "typeOfSale",
  "condition",
];

export const commercialFinanceCriteriaFilterList = [
  "ageOfAsset",
  "ageOfAssetAtEnd",
  "assetType",
  "deposit",
  "gst",
  "timeInBusiness",
  "professionalServices",
  "livingArrangements",
  "loanAmount",
  "score",
  "typeOfSale",
  "condition",
];

export const businessFinanceCriteriaFilterList = [
  "gst",
  "timeInBusiness",
  "professionalServices",
  "livingArrangements",
  "loanAmount",
  "score",
];

export const defaultCreditScoreValues = {
  [ApplicationType.Consumer]: ["ONE_1.0_X_CR", "VSA_2.0_X_CR", "VS_1.1_X_NR"],
  [ApplicationType.Personal]: ["ONE_1.0_X_CR", "VSA_2.0_X_CR", "VS_1.1_X_NR"],
  [ApplicationType.Commercial]: ["CCAI_2.0_YX_CR", "CCAI_2.0_YX_NR", "VS_1.1_YX_NR"],
  [ApplicationType.Business]: ["CCAI_2.0_YX_CR", "CCAI_2.0_YX_NR", "VS_1.1_YX_NR"],
};

export const earlyPayDefaultCreditScoreValues = {
  ...defaultCreditScoreValues,
  [ApplicationType.Commercial]: ["CCAI_2.0_YX_NR"],
};

export const personalFinanceCriteriaFilterList = [
  "ageOfAsset",
  "ageOfAssetAtEnd",
  "assetType",
  "dateOfBirth",
  // "deposit",
  "employmentType",
  "livingArrangements",
  "loanAmount",
  "score",
  "timeOfEmployment",
  "typeOfSale",
];

export const EQScoreTypesCommercial = [
  {
    label: "Equifax One Score 1.0 Comprehensive Consumer + Commercial",
    value: "ONE_1.0_XY_CR",
    permissionType: "XY",
    productDataLevel: "C",
  },
  {
    label: "Equifax Apply 2.0 Comprehensive Consumer + Commercial",
    value: "VSA_2.0_XY_CR",
    permissionType: "XY",
    productDataLevel: "C",
  },
  {
    label: "Equifax Apply 2.0 Negative Consumer + Commercial",
    value: "VSA_2.0_XY_NR",
    permissionType: "XY",
    productDataLevel: "N",
  },
  {
    label: "Equifax Commercial Apply 2.0 Comprehensive Commercial + Consumer",
    value: "CCAI_2.0_YX_CR",
    permissionType: "YX",
    productDataLevel: "C",
  },
  {
    label: "Equifax Commercial Apply 2.0 Negative Commercial + Consumer",
    value: "CCAI_2.0_YX_NR",
    permissionType: "YX",
    productDataLevel: "N",
  },
  {
    label: "VedaScore 1.1 Negative Consumer + Commercial",
    value: "VS_1.1_XY_NR",
    permissionType: "XY",
    productDataLevel: "N",
  },
  {
    label: "VedaScore 1.1 Negative Commercial + Consumer",
    value: "VS_1.1_YX_NR",
    permissionType: "YX",
    productDataLevel: "N",
  },
  {
    label: "Equifax One Score 1.0 Comprehensive Consumer",
    value: "ONE_1.0_X_CR",
    permissionType: "X",
    productDataLevel: "C",
  },
  {
    label: "Equifax Apply 2.0 Comprehensive Consumer",
    value: "VSA_2.0_X_CR",
    permissionType: "X",
    productDataLevel: "C",
  },
  {
    label: "Equifax Apply 2.0 Negative Consumer",
    value: "VSA_2.0_X_NR",
    permissionType: "X",
    productDataLevel: "N",
  },
  {
    label: "VedaScore 1.1 Negative Consumer",
    value: "VS_1.1_X_NR",
    permissionType: "X",
    productDataLevel: "N",
  },
];

export const EQScoreTypesPersonal = [
  {
    label: "Equifax One Score 1.0 Comprehensive Consumer",
    value: "ONE_1.0_X_CR",
    permissionType: "X",
    productDataLevel: "C",
  },
  {
    label: "Equifax Apply 2.0 Comprehensive Consumer",
    value: "VSA_2.0_X_CR",
    permissionType: "X",
    productDataLevel: "C",
  },
  {
    label: "Equifax Apply 2.0 Negative Consumer",
    value: "VSA_2.0_X_NR",
    permissionType: "X",
    productDataLevel: "N",
  },
  {
    label: "VedaScore 1.1 Negative Consumer",
    value: "VS_1.1_X_NR",
    permissionType: "X",
    productDataLevel: "N",
  },
];

export const CreditScoreTypes = {
  [ApplicationType.Consumer]: EQScoreTypesCommercial, // Use same list of consumer as commercial
  [ApplicationType.Personal]: EQScoreTypesPersonal,
  [ApplicationType.Commercial]: EQScoreTypesCommercial,
  [ApplicationType.Business]: EQScoreTypesCommercial,
};

export const getCriteriaFilterList = {
  [ApplicationType.Consumer]: consumerFinanceCriteriaFilterList,
  [ApplicationType.Commercial]: commercialFinanceCriteriaFilterList,
  [ApplicationType.Personal]: personalFinanceCriteriaFilterList,
  [ApplicationType.Business]: businessFinanceCriteriaFilterList,
};

export const sortList = [
  ["fit", "desc"],
  ["repayments", "asc"],
  ["rate", "asc"],
  ["loanAmount", "asc"],
  ["fees", "asc"],
];

export const employerWorkStatus = [
  {
    label: "Current",
    value: "current",
  },
  {
    label: "Previous",
    value: "previous",
  },
];

export const employmentTypes = {
  FULL_TIME: "Full-time",
  PART_TIME: "Part-time",
  CASUAL: "Casual",
  CONTRACT: "Contract",
  SELF_EMPLOYED: "Self-employed",
  BENEFITS: "Benefits",
  UNEMPLOYED: "Unemployed",
};

export const employmentTypeList = Object.values(employmentTypes).map((type) => ({ label: type }));

export const userType = {
  user: "user",
  owner: "owner",
  admin: "admin",
  support: "support",
  master: "master",
};

export const SERVICE_INVOICE_PAID_BY_TYPES = {
  ORGANISATION: "ORGANISATION",
  USER: "USER",
};

export const makeType = {
  Abarth: "Abarth",
  Alpine: "Alpine",
  AstonMartin: "Aston Martin",
  Audi: "Audi",
  Bentley: "Bentley",
  BMW: "BMW",
  BMW_ALPINA: "BMW ALPINA",
  Caterham: "Caterham",
  Chevrolet: "Chevrolet",
  Chrysler: "Chrysler",
  Citroen: "Citroen",
  Ferrari: "Ferrari",
  Fiat: "Fiat",
  Ford: "Ford",
  Genesis: "Genesis",
  GWM: "GWM",
  Haval: "Haval",
  Honda: "Honda",
  Hyundai: "Hyundai",
  Isuzu: "Isuzu",
  Iveco: "Iveco",
  Jaguar: "Jaguar",
  Jeep: "Jeep",
  Kia: "Kia",
  Lamborghini: "Lamborghini",
  LandRover: "Land Rover",
  LDV: "LDV",
  Lexus: "Lexus",
  Lotus: "Lotus",
  Mahindra: "Mahindra",
  Maserati: "Maserati",
  Mazda: "Mazda",
  McLaren: "McLaren",
  MercedesBenz: "Mercedes-Benz",
  Maybach: "Maybach",
  MG: "MG",
  MINI: "MINI",
  Mitsubishi: "Mitsubishi",
  Morgan: "Morgan",
  Nissan: "Nissan",
  Peugeot: "Peugeot",
  Porsche: "Porsche",
  Ram: "Ram",
  Renault: "Renault",
  RollsRoyce: "Rolls-Royce",
  Skoda: "Skoda",
  Ssangyong: "Ssangyong",
  Subaru: "Subaru",
  Suzuki: "Suzuki",
  Tesla: "Tesla",
  Toyota: "Toyota",
  Volkswagen: "Volkswagen",
  Volvo: "Volvo",
};

export const assetTypesList = [
  {
    label: "Residential property (occupying)",
    value: "Residential property (occupying)",
  },
  {
    label: "Investment property",
    value: "Investment property",
  },
  {
    label: "Commercial property",
    value: "Commercial property",
  },
  {
    label: "Motor vehicle",
    value: "Motor vehicle",
  },
  {
    label: "Cash (savings)",
    value: "Cash (savings)",
  },
  {
    label: "Investments (shares)",
    value: "Investments (shares)",
  },
  {
    label: "Superannuation",
    value: "Superannuation",
  },
  {
    label: "Other",
    value: "Other",
  },
];

export const liabilitiesTypesList = [
  {
    label: "Mortgage",
    value: "Mortgage",
  },
  {
    label: "Motor vehicle",
    value: "Motor vehicle",
  },
  {
    label: "Credit card",
    value: "Credit card",
  },
  {
    label: "Personal loan",
    value: "Personal loan",
  },
  {
    label: "Afterpay, Zip, etc…",
    value: "Afterpay, Zip, etc…",
  },
  {
    label: "Other",
    value: "Other",
  },
];

export const incomeTypesList = [
  {
    label: "Primary",
    value: "Primary",
  },
  {
    label: "Secondary",
    value: "Secondary",
  },
  {
    label: "Spouse",
    value: "Spouse",
  },
  {
    label: "Investment property",
    value: "Investment property",
  },
  {
    label: "Dividends",
    value: "Dividends",
  },
  {
    label: "Superannuation",
    value: "Superannuation",
  },
  {
    label: "Pension",
    value: "Pension",
  },
  {
    label: "Trust",
    value: "Trust",
  },
  {
    label: "Benefits",
    value: "Benefits",
  },
  {
    label: "Other",
    value: "Other",
  },
];

export const expensesTypeList = [
  {
    label: "Rent",
    value: "Rent",
  },
  {
    label: "Utilities",
    value: "Utilities",
  },
  {
    label: "Groceries",
    value: "Groceries",
  },
  {
    label: "Dining Out",
    value: "Dining Out",
  },
  {
    label: "Insurance",
    value: "Insurance",
  },
  {
    label: "Telecommunications",
    value: "Telecommunications",
  },
  {
    label: "Subscription TV",
    value: "Subscription TV",
  },
  {
    label: "Education and Childcare",
    value: "Education and Childcare",
  },
  {
    label: "Vehicles and Transport",
    value: "Vehicles and Transport",
  },
  {
    label: "Personal Care",
    value: "Personal Care",
  },
  {
    label: "Health",
    value: "Health",
  },
  {
    label: "Department Stores",
    value: "Department Stores",
  },
  {
    label: "Retail",
    value: "Retail",
  },
  {
    label: "Home Improvement",
    value: "Home Improvement",
  },
  {
    label: "Entertainment",
    value: "Entertainment",
  },
  {
    label: "Gym and other memberships",
    value: "Gym and other memberships",
  },
  {
    label: "Travel",
    value: "Travel",
  },
  {
    label: "Pet Care",
    value: "Pet Care",
  },
  {
    label: "Uncategorized Debts",
    value: "Uncategorized Debts",
  },
];

export const frequencyTypes = {
  Weekly: "Weekly",
  Fortnightly: "Fortnightly",
  Monthly: "Monthly",
  Annually: "Annually",
};

export const frequencyList = [
  {
    label: "Weekly",
    value: "Weekly",
  },
  {
    label: "Fortnightly",
    value: "Fortnightly",
  },
  {
    label: "Monthly",
    value: "Monthly",
  },
];

export const frequencyForIncomeList = [
  {
    label: "Weekly",
    value: "Weekly",
  },
  {
    label: "Fortnightly",
    value: "Fortnightly",
  },
  {
    label: "Monthly",
    value: "Monthly",
  },
  {
    label: "Annually",
    value: "Annually",
  },
];

export const industryList = [
  {
    label: "ACCOMMODATION AND FOOD SERVICES",
    value: "ACCOMMODATION AND FOOD SERVICES",
  },
  {
    label: "ADMINISTRATIVE AND SUPPORT SERVICES",
    value: "ADMINISTRATIVE AND SUPPORT SERVICES",
  },
  {
    label: "AGRICULTURE, FORESTRY AND FISHING",
    value: "AGRICULTURE, FORESTRY AND FISHING",
  },
  {
    label: "ARTS AND RECREATION SERVICES",
    value: "ARTS AND RECREATION SERVICES",
  },
  {
    label: "CONSTRUCTION",
    value: "CONSTRUCTION",
  },
  {
    label: "EDUCATION AND TRAINING",
    value: "EDUCATION AND TRAINING",
  },
  {
    label: "ELECTRICITY, GAS, WATER AND WASTE SERVICES",
    value: "ELECTRICITY, GAS, WATER AND WASTE SERVICES",
  },
  {
    label: "FINANCIAL AND INSURANCE SERVICES",
    value: "FINANCIAL AND INSURANCE SERVICES",
  },
  {
    label: "HEALTH CARE AND SOCIAL ASSISTANCE",
    value: "HEALTH CARE AND SOCIAL ASSISTANCE",
  },
  {
    label: "INFORMATION MEDIA AND TELECOMMUNICATIONS",
    value: "INFORMATION MEDIA AND TELECOMMUNICATIONS",
  },
  {
    label: "MANUFACTURING",
    value: "MANUFACTURING",
  },
  {
    label: "MINING",
    value: "MINING",
  },
  {
    label: "OTHER SERVICES",
    value: "OTHER SERVICES",
  },
  {
    label: "PROFESSIONAL, SCIENTIFIC AND TECHNICAL SERVICES",
    value: "PROFESSIONAL, SCIENTIFIC AND TECHNICAL SERVICES",
  },
  {
    label: "PUBLIC ADMINISTRATION AND SAFETY",
    value: "PUBLIC ADMINISTRATION AND SAFETY",
  },
  {
    label: "RENTAL HIRING AND REAL ESTATE SERVICES",
    value: "RENTAL HIRING AND REAL ESTATE SERVICES",
  },
  {
    label: "RETAIL TRADE",
    value: "RETAIL TRADE",
  },
  {
    label: "TRANSPORT, POSTAL AND WAREHOUSING",
    value: "TRANSPORT, POSTAL AND WAREHOUSING",
  },
  {
    label: "WHOLESALE TRADE",
    value: "WHOLESALE TRADE",
  },
];

export const validIndustryList = industryList.map((item) => item.value);

export const customerTitleList = [
  {
    label: "Mr",
    value: "Mr",
  },
  {
    label: "Mrs",
    value: "Mrs",
  },
  {
    label: "Ms",
    value: "Ms",
  },
  {
    label: "Miss",
    value: "Miss",
  },
];

export const validCustomerTitle = ["Mr", "Mrs", "Ms", "Miss"];

export const RESIDENCY_STATUS = {
  AUSTRALIAN_CITIZEN: "Australian Citizen",
  PERMANENT_RESIDENT: "Permanent Resident",
  NEW_ZEALAND_CITIZEN: "New Zealand Citizen",
  WORKING_VISA: "Working Visa",
  STUDENT_VISA: "Student Visa",
  OTHER_VISA: "Other Visa",
} as const;

export const residencyStatusList = [
  RESIDENCY_STATUS.AUSTRALIAN_CITIZEN,
  RESIDENCY_STATUS.PERMANENT_RESIDENT,
  RESIDENCY_STATUS.NEW_ZEALAND_CITIZEN,
  RESIDENCY_STATUS.WORKING_VISA,
  RESIDENCY_STATUS.STUDENT_VISA,
  RESIDENCY_STATUS.OTHER_VISA,
];

export const residencyStatusOptions = residencyStatusList.map((label) => ({ label }));

export const VISA_RESIDENCY_STATUS = {
  WORKING: RESIDENCY_STATUS.WORKING_VISA,
  STUDENT: RESIDENCY_STATUS.STUDENT_VISA,
  OTHER: RESIDENCY_STATUS.OTHER_VISA,
} as const;

export const visaResidencyStatusList = Object.values(VISA_RESIDENCY_STATUS);

export const isVisaResidencyStatus = (status?: string) =>
  visaResidencyStatusList.includes(status as (typeof visaResidencyStatusList)[number]);

export const visaOptionsByResidencyStatus: Record<(typeof visaResidencyStatusList)[number], string[]> = {
  [VISA_RESIDENCY_STATUS.WORKING]: [
    "Subclass 186 - Employer Nomination Scheme visa",
    "Subclass 189 - Skilled Independent visa",
    "Subclass 190 - Skilled Nominated visa",
    "Subclass 191 - Permanent Residence (Skilled Regional) visa",
    "Subclass 403 - Temporary Work (International Relations) visa",
    "Subclass 482 - Skills in Demand visa",
    "Subclass 485 - Temporary Graduate visa",
    "Subclass 491 - Skilled Work Regional (Provisional) visa",
    "Subclass 494 - Skilled Employer Sponsored Regional (Provisional) visa",
    "Subclass 858 - National Innovation visa",
    "Subclass 887 - Skilled Regional visa",
    "Subclass 888 - Business Innovation and Investment (Permanent) visa",
  ],
  [VISA_RESIDENCY_STATUS.STUDENT]: [],
  [VISA_RESIDENCY_STATUS.OTHER]: [
    "Subclass 010 - Bridging visa A - BVA",
    "Subclass 020 - Bridging visa B - BVB",
    "Subclass 100 - Partner (Migrant) visa",
    "Subclass 101 - Child visa",
    "Subclass 102 - Adoption visa",
    "Subclass 103 - Parent visa",
    "Subclass 114 - Aged Dependent Relative visa",
    "Subclass 115 - Remaining Relative visa",
    "Subclass 116 - Carer visa",
    "Subclass 117 - Orphan Relative visa",
    "Subclass 119 - Regional Sponsored Migration Scheme visa",
    "Subclass 120 - Labour Agreement visa",
    "Subclass 121 - Employer Nomination Scheme visa",
    "Subclass 124 - Distinguished Talent visa",
    "Subclass 132 - Business Talent visa",
    "Subclass 143 - Contributory Parent visa",
    "Subclass 151 - Former Resident visa",
    "Subclass 155 - Resident Return visa",
    "Subclass 157 - Resident Return visa",
    "Subclass 176 - Skilled Sponsored visa",
    "Subclass 187 - Regional Sponsored Migration Scheme visa",
    "Subclass 188 - Business Innovation and Investment (Provisional) visa",
    "Subclass 200 - Refugee visa",
    "Subclass 201 - In-country Special Humanitarian visa",
    "Subclass 202 - Global Special Humanitarian visa",
    "Subclass 203 - Emergency Rescue visa",
    "Subclass 204 - Woman at Risk visa",
    "Subclass 444 - Special Category visa",
    "Subclass 489 - Skilled Regional (Provisional) visa",
    "Subclass 801 - Partner visa",
    "Subclass 802 - Child visa",
    "Subclass 804 - Aged Parent visa",
    "Subclass 808 - Confirmatory (Residence) visa",
    "Subclass 820 - Partner visa",
    "Subclass 835 - Remaining Relative visa",
    "Subclass 836 - Carer visa",
    "Subclass 837 - Orphan Relative visa",
    "Subclass 838 - Aged Dependent Relative visa",
    "Subclass 857 - Regional Sponsored Migration Scheme visa",
    "Subclass 864 - Contributory Aged Parent visa",
    "Subclass 866 - Protection visa",
    "Subclass 890 - Business Owner visa",
    "Subclass 891 - Investor visa",
    "Subclass 892 - State or Territory Sponsored Business Owner visa",
    "Subclass 893 - State or Territory Sponsored Investor visa",
  ],
};

export const validCustomerAssetType = [
  "Residential property (occupying)",
  "Investment property",
  "Commercial property",
  "Motor vehicle",
  "Cash (savings)",
  "Investments (shares)",
  "Superannuation",
  "Other",
];

export const validLiabilityType = [
  "Mortgage",
  "Motor vehicle",
  "Credit card",
  "Personal loan",
  "Afterpay, Zip, etc…",
  "Other",
];

// export const validIncomeTypesList = [
//   "Primary",
//   "Secondary",
//   "Investment property",
//   "Dividends",
//   "Superannuation",
//   "Pension",
//   "Trust",
//   "Benefits",
//   "Other",
// ];

// export const validExpenseTypesList = [
//   "Rent",
//   "Utilities",
//   "Groceries",
//   "Dining Out",
//   "Insurance",
//   "Telecommunications",
//   "Subscription TV",
//   "Education and Childcare",
//   "Vehicles and Transport",
//   "Personal Care",
//   "Health",
//   "Department Stores",
//   "Retail",
//   "Home Improvement",
//   "Entertainment",
//   "Gym and other memberships",
//   "Travel",
//   "Pet Care",
//   "Uncategorized Debts",
// ];

export const calculationMethods = ["Chattel Mortgage", "Consumer finance", "Lease"];

export const StateList = [
  "ACT",
  "NSW",
  "NT",
  "QLD",
  "SA",
  "TAS",
  "VIC",
  "WA",
  // "OTHER"
];

export const validExpenseTypesList = [
  "Rent",
  "Utilities",
  "Groceries",
  "Dining Out",
  "Insurance",
  "Telecommunications",
  "Subscription TV",
  "Education and Childcare",
  "Vehicles and Transport",
  "Personal Care",
  "Health",
  "Department Stores",
  "Retail",
  "Home Improvement",
  "Entertainment",
  "Gym and other memberships",
  "Travel",
  "Pet Care",
  "Uncategorized Debts",
];

export const validFrequencyList = ["Weekly", "Fortnightly", "Monthly", "Annually"];

export const RepaymentStructure = [
  // "Custom Payments",
  // "Group Payments",
  "Single Payments",
];

export const ConditionFieldOptions = ["New", "Demo", "Used"];

export const userTypeOptions = ["master", "owner", "admin", "user", "support"];

export const userTypes = {
  owner: "owner",
};

export const PermissionAccessOptions = [
  {
    label: "all",
    value: "all",
  },
  {
    label: "self",
    value: "self",
  },
  {
    label: "org",
    value: "own",
  },
];

export const getApplicationTab = {
  quote: "quote",
  application: "application",
  calculator: "calculator",
  organisation: "organisation",
  user: "user",
  invoice: "invoice",
};

export const getIsConsumerOrPersonalApplication = (applicationType: ApplicationType): boolean =>
  applicationType === ApplicationType.Consumer || applicationType === ApplicationType.Personal;

export const getIsCommercialOrBusinessApplication = (applicationType: ApplicationType): boolean =>
  applicationType === ApplicationType.Commercial || applicationType === ApplicationType.Business;

export const getIsAssetLoan = (applicationType: ApplicationType): boolean =>
  applicationType === ApplicationType.Commercial || applicationType === ApplicationType.Consumer;

export const applicationTypeList = [
  {
    label: "Consumer Asset",
    value: ApplicationType.Consumer,
    key: "startConsumerAssetApp",
  },
  {
    label: "Commercial Asset",
    value: ApplicationType.Commercial,
    key: "startCommercialAssetApp",
  },
  {
    label: "Commercial",
    value: ApplicationType.Commercial,
    key: "startCommercialApp",
  },
  {
    label: "Unsecured Consumer Loan",
    value: ApplicationType.Personal,
    key: "startPersonalAssetApp",
  },
  {
    label: "Unsecured Business Loan",
    value: ApplicationType.Business,
    key: "startBusinessAssetApp",
  },
];

const quoteApplicationTypeList = [
  {
    label: "Consumer Asset",
    value: ApplicationType.Consumer,
    key: "startConsumerAssetApp",
  },
  {
    label: "Commercial Asset",
    value: ApplicationType.Commercial,
    key: "startCommercialAssetApp",
  },
  {
    label: "Unsecured Consumer Loan",
    value: ApplicationType.Personal,
    key: "startPersonalAssetApp",
  },
  {
    label: "Unsecured Business Loan",
    value: ApplicationType.Business,
    key: "startBusinessAssetApp",
  },
];

const calculatorApplicationTypeList = [
  {
    label: "Consumer Asset",
    value: ApplicationType.Consumer,
    key: "startConsumerAssetApp",
  },
  {
    label: "Commercial Asset",
    value: ApplicationType.Commercial,
    key: "startCommercialAssetApp",
  },
  {
    label: "Unsecured Consumer Loan",
    value: ApplicationType.Personal,
    key: "startPersonalAssetApp",
  },
  {
    label: "Unsecured Business Loan",
    value: ApplicationType.Business,
    key: "startBusinessAssetApp",
  },
];

export const getApplicationTypeList = {
  quote: quoteApplicationTypeList,
  application: applicationTypeList,
  calculator: calculatorApplicationTypeList,
};

export const earlyPayApplicationTypeList = {
  ...getApplicationTypeList,
  application: applicationTypeList.filter((item) => item.label === "Commercial Asset"),
};

export const applicationPurpose = {
  loanPurposeDemo: "loanPurposeDemo",
};

export const getStartApplicationUrl = {
  quote: `application/start/quote`,
  application: `application/start`,
  calculator: `application/start/calculator`,
};

export const defaultRevenueFeesList = [
  {
    name: "financedFee",
    label: "Financed fee",
    key: "fee",
    value: 0,
  },
  {
    name: "financedBrokerage",
    label: "Financed fee",
    key: "brokerage",
    value: 0,
  },
  {
    name: "unFinancedFee",
    label: "Unfinanced fee",
    key: "fee",
    value: 0,
  },
  {
    name: "unFinancedBrokerage",
    label: "Unfinanced fee",
    key: "brokerage",
    value: 0,
  },
  {
    name: "accountFee",
    label: "Account fee (Net)",
    key: "fee",
    value: 0,
  },
];

export const REFERRAL_FEE = "referralFee";

export const typesOfFeesWithKey = [
  {
    label: "Origination Fee",
    value: "originationFee",
  },
  {
    label: "Inspection Fee",
    value: "inspectionFee",
  },
  // {
  //   label: "Application Fee",
  //   value: "applicationFee",
  // },
  {
    label: "Registration Fee",
    value: "registrationFee",
  },
  {
    label: "Establishment Fee",
    value: "establishmentFee",
  },
  {
    label: "Document Fee",
    value: "documentFee",
  },
  {
    label: "Account Fee",
    value: "accountFee",
  },
  {
    label: "Referral Fee",
    value: REFERRAL_FEE,
  },
  {
    label: "Monthly Fee",
    value: "monthlyFee",
  },
];

export const typesOfFees = [
  "originationFee",
  "inspectionFee",
  // 'applicationFee',
  "registrationFee",
  "establishmentFee",
  "documentFee",
  "accountFee",
  REFERRAL_FEE,
  "monthlyFee",
];

export const FEE_KEYS = {
  originationFee: "originationFee",
  inspectionFee: "inspectionFee",
  registrationFee: "registrationFee",
  establishmentFee: "establishmentFee",
  documentFee: "documentFee",
  accountFee: "accountFee",
  referralFee: REFERRAL_FEE,
  monthlyFee: "monthlyFee",
} as const;

export const SUCCESS_MESSAGE = {
  linkMsg: "Link has been sent successfully.",
  generatePdf: "PDF generated successfully.",
  asic: "ASIC data retrieved successfully.",
  fetchMsg: "Data fetched successfully.",
  creditFile: "Credit file retrieved successfully.",
  bankStatements: "Bank statements link has been sent.",
  privacy: "Privacy statement link has been sent.",
  disclosure: "Proposal Disclosure Statement successfully has been sent..",
  idVerification: "Identity verification link has been sent.",
  successLinkMsg: "Request sent. Awaiting customer response.",
  fileUploadSuccess: "File uploaded successfully.",
  applicationSubmitted: "Application submitted successfully.",
  organisationCreate: "Organisation created successfully.",
  organisationUpdate: "Organisation updated successfully.",
  applicationLinkedSuccessMsg: "Application linked successfully.",
  fetchPreviewDocumentSuccess: "Preview document fetched successfully.",
  fileRemovedSuccess: "File removed successfully.",
  documentsSubmitted: "All documents have been submitted successfully.",
  insuranceQuoteCreated: "Insurance quote created successfully.",
  insuranceQuoteSentToCustomer: "Insurance quote sent to customer successfully.",
  productQuoteCreated: "Product quote created successfully.",
  productQuoteUpdated: "Quote note updated successfully.",
  productQuoteSetPrimary: "Primary quote updated successfully.",
  productQuoteRemoved: "Product quote removed successfully.",
  productQuoteSentToCustomers: "Product quotes sent to customers successfully.",
  applicationStatusUpdatedSuccessMsg: "Application status updated successfully.",
  applicationTypeUpdatedSuccessMsg: "Application type updated successfully.",
  applicationOwnershipTransferredSuccessMsg: "Application ownership transferred successfully.",
  quoteStatusUpdatedSuccessMsg: "Quote status updated successfully.",
  documentRequestLinkSent: "Document request link has been sent.",
  financialStatementUploaded: "Financial statement uploaded successfully.",
  applicationFollowersUpdatedSuccessMsg: "Followers updated successfully.",
  documentLinkSent: "Document link sent successfully.",
  resendUserInvitation: "User invitation resent successfully.",
  invoiceGenerated: "Invoice generated successfully.",
  invoiceResent: "Invoice resent successfully.",
  assetInvoiceRequestSent: "Invoice request sent successfully.",
  tenantUpdated: "Tenant updated successfully.",
};

export const ALLOWED_DOCUMENT_TYPE = [
  "application/pdf",
  "image/jpeg",
  "image/jpg",
  // "image/gif",
  "image/png",
];

/** MIME types allowed when uploading a settings document template (Word only). */
export const ALLOWED_DOCUMENT_TEMPLATE_FILE_TYPES = [
  "application/msword",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
];

export const ALLOWED_ASSET_DOCUMENT_TYPE = [
  "application/pdf",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];

export const VALID_DOCUMENT_TYPE_EXTENSION = ".pdf, .jpg, .jpeg, .png"; // .doc, .docx, .gif

export const MAX_DOCUMENT_UPLOAD_SIZE = 10 * 1024 * 1024; // 10 MB in bytes

export const ERRORS_MESSAGE = {
  fetchErrorMsg: "Something went wrong",
  documentTypeMsg: "File type must be pdf, jpg, jpeg, png only",
  documentSizeMsg: "File size exceeds the limit (10 MB)",
};

export const VALIDATION_MESSAGE = {
  australianMobileNumber: "Enter a valid Australian mobile number.",
};

/** The copy button's label, and what the snackbar says once it is clicked. */
export const COPY_BUTTON_COPY = {
  copy: "Copy",
  copied: "Copied to clipboard",
  copyFailed: "Could not copy to the clipboard. Please select and copy the text instead.",
} as const;

export const FILE_AWAITING_MESSAGE = {
  gettingEquifaxCreditPDFMsg: "Waiting for Equifax to send the PDF file",
  gettingVehicleDataMsg: "Waiting for vehicle lookup data",
  gettingPPSRFileMsg: "Waiting for the PPSR data and certificate",
  gettingInsuranceQuoteDataMsg: "Waiting for Insurance quote data",
};

export const errorField = [
  // "addresses[0].streetAddress",
  "addresses[0].city",
  "addresses[0].state",
  "addresses[0].postCode",
  "emails?.slice(-1)[0].address",
  "phoneNumbers?.slice(-1)[0].number",
];

// export const errorForAddress = [
//   "addresses[0].yearsAt",
//   "addresses[0].monthsAt",
//   "addresses[0].city",
//   "addresses[0].state",
//   "addresses[0].postCode",
// ];

export const agreementDetail = [
  `you have the legal authority to submit this personal loan
application on behalf of the borrower(s); and`,
  `the information provided to the lender in this application is
  accurate; and`,
  `you have disclosed any information known to you which may be
  relevant to lender’s decision in relation to the application; and`,
  `you must not engage in any misleading or deceptive conduct, or
  made any representation to the applicant(s) as to the likelihood of
  the success of their application; and`,
  `Credit contract has been assessed as suitable at this time as (a) 
  the customer can meet repayments and (b) can do so without substantial 
  hardship and (c) contract meets customer requirements and objectives; and`,
  `If any insurance or warranties (such as gap insurance or extended
    warranty) is to be financed under this loan, you the Introducer,
    confirm and warrant that:`,
];

export const pointDetail = [
  `If you are a mortgage broker, you represent and warrant that you
have complied with your obligation to act in the customer’s best
interests;`,
  `you have made reasonable inquiries of the applicant(s) about their
requirements and objectives in respect of each insurance or
warranty;`,
  `you have assessed that each insurance or warranty proposed to be
financed under this loan meets the applicant(s) requirements and
objectives, and (if applicable) that the warranty provides a genuine
benefit over and above any statutory warranty;`,
  `you have explained the excess fee, the coverage, and the limitations
of the relevant insurance or warranty, and the cost of the insurance
premium or warranty fee to the applicant(s) (and compared the cost of
the insurance premium or warranty fee to the value of the motor
vehicle). The applicant(s) was/were satisfied with the features,
limitations and cost; and`,
  `you have not engaged in pressure selling, or any conduct that could
be misleading, deceptive or dishonest. `,
  `you have complied with all requirements under the Deferred Sales
Model for add-on insurance products.`,
  `I confirm that the distribution of this product is consistent with
the current Target Market Determination.`,
];

export const whatIsThePurposeOfThisApplicationOption = [
  "Purchase the asset plus finance insurances",
  "Purchase the asset",
  "Refinance loan on the asset",
  "Refinance loan on the asset plus finance insurances",
];
export const whatIsThePurposeOfThisApplicationDetail =
  "Please specify the purpose of the application. For example, purchase the asset, Refinance loan on the asset.";

export const whyDoesThisLoanTermSuitYourRequirementsOption = [
  "Want the maximum amount of time with the minimum repayment",
  "Want to be able to pay off the loan over the selected term as it suits my budget",
  "I want to pay off the loan as quickly as possible (and acknowledge that fees and charges apply for early payout of the loan)",
  "I will be looking to sell the car/ trade in at the end of the loan term",
  "Other",
];
export const whyDoesThisLoanTermSuitYourRequirementsDetail = "Why does this loan term suits your requirement?";

export const whatAreYouLookingForInYourLoanOption = [
  "Competitive Interest Rate",
  "Service",
  "Broker Recommendation",
  "I can make additional repayments at no cost",
  "I can repay the loan early (fees & charges apply)",
  "A balloon repayment",
];
export const whatAreYouLookingForInYourLoanDetail = "Please specify what are you looking for in your loan.";

export const anyForeseeableChangesImpactingLoanRepaymentOption = [
  "End of employment contract/ loss of employment",
  "Leaving employment",
  "Increased debt repayment for a new/ existing loan",
  "Large expenditure",
  "Medical treatment/ illness",
  "Extended unpaid leave (e.g. study or parental leave)",
  "Change to family situation",
  "Retirement",
  "Buying a house",
  "Other",
  "No",
];

export const anyForeseeableChangesImpactingLoanRepaymentDetail =
  "Do you plan or anticipate any foreseeable changes to your personal circumstances that may adversely impact your ability to repay the loan.";

export const explainWhyIsThisLoanNotUnsuitableForTheApplicantDetail =
  "Explain why you are satisfied this loan is NOT unsuitable for the applicant?";

export const whatToDoWithBalloonPaymentAtTheEndOfTheLoanTermOption = [
  "Payout",
  "Refinance the loan",
  "Sell the asset",
  "Trade in for a new vehicle",
];

export const whatToDoWithBalloonPaymentAtTheEndOfTheLoanTermDetail =
  "What do you intend to do at the end of the loan term with the balloon payment?";

export const howApplicantIntendToDoLoanRepaymentAfterChangeDetail =
  "How does the applicant(s) intend to meet their loan repayments following the planned or anticipated change?";

export const increaseInLoanAmountForFinancingCostOfInsuranceDetail =
  "Are you aware that financing the cost of insurances or add-ons will increase the loan amount and interest paid over the loan term. This is relevant for the applications where one or more insurance premiums are being financed.";

export const balloonPaymentAtTheEndOfTheLoanDetail =
  "Do you understand and acknowledge that you will be required to make a large payment (balloon payment) at the end of the loan and will pay interest on the balloon over the term of the loan?";

export const serviceChargesList = [
  {
    service: "Glasses Guide",
    apiCallCount: "10",
    singleApiCallPrice: "0.00",
  },
  {
    service: "Blue flag",
    apiCallCount: "2",
    singleApiCallPrice: "0.70",
  },
  {
    service: "ASIC Extract",
    apiCallCount: "1",
    singleApiCallPrice: "4.64",
  },
  {
    service: "ASIC Extract",
    apiCallCount: "5",
    singleApiCallPrice: "14.73",
  },
  {
    service: "PPSR",
    apiCallCount: "2",
    singleApiCallPrice: "6.00",
  },
  {
    service: "ID verification",
    apiCallCount: "10",
    singleApiCallPrice: "4.20",
  },
  {
    service: "Equifax report",
    apiCallCount: "2",
    singleApiCallPrice: "10.03",
  },
  {
    service: "Equifax report",
    apiCallCount: "1",
    singleApiCallPrice: "11.03",
  },
  {
    service: "Equifax report",
    apiCallCount: "5",
    singleApiCallPrice: "16.81",
  },
  {
    service: "Bank statements",
    apiCallCount: "2",
    singleApiCallPrice: "3.50",
  },
];

export const serviceChargesHeader = ["Service", "Total request", "Service charge", "Total charge", ""];

export const inVoiceHeader = ["Date", "User", "Period", "Amount", "Status", ""];

export const cellAlign = "center";
export const fieldRequiredMessage = {
  yearsAt: "Addresses years at is required",
  monthsAt: "Addresses months at is required",
  assetValue: "Asset value is required",
  netAssetValue: "Net value is required",
  luxuryGst: "Luxury Gst is required",
  assetType: "Asset type is required",
  typeOfSale: "Type of sale is required",
  ageOfAsset: "Age of asset is required",
  glassesMake: "Glasses make is required",
  glassesModel: "Glasses model is required",
  glassesVariant: "Glasses variant is required",
  customerTitle: "Title is required",
  firstName: "First name is required",
  middleNames: "middle name is required",
  lastName: "Last name is required",
  dateOfBirth: "Date of birth is required",
  IDNumber: "ID number is required",
  IDCardNumber: "ID card number is required",
  number: "Phone number is required",
  address: "Email address is required",
  fullAddress: "Address is required",
  introducerDeclarationAgree: "Agreement is required",
  make: "Make is required",
  model: "Model is required",
  variant: "Variant is required",
  IDExpiryDate: "Licence expiry date is required",
  monthAtInValid: "MonthsAt  are invalid",
  customerAssetsErrMsg: {
    assetType: "Type is required",
    value: "Amount is required",
    description: "Description is required",
  },
  liabilityErrMsg: {
    liabilitiesType: "Liability is required",
    outstandingAmount: "Amount is required",
    limit: "Limit is required",
    financier: "Financier is required",
    repaymentFrequency: "Frequency is required",
    repaymentAmount: "Amount is required",
    description: "Description is required",
    shareOfLiability: "Share of liability is required",
  },
  incomeErrMsg: {
    incomeType: "Income type is required",
    amount: "Amount is required",
    frequency: "Frequency is required",
  },
  expenseErrMsg: {
    expensesType: "Expense type is required",
    amount: "Amount is required",
    frequency: "Frequency is required",
    shareOfExpense: "Share of expense is required",
  },
  employeeErrMsg: {
    entityName: "Name is required",
    status: "Status is required",
    occupation: "Occupation is required",
    manager: "Manager name is required",
    phoneNumber: "number is required",
    industry: "Industry is required",
    timeOfEmployment: "Time Of Employment is required",
    fullAddress: "Address is required",
    city: "City is required",
    state: "State is required",
  },
  customErrMsg: {
    fullAddress: "Only australian address is allowed",
    dateOfBirth: "Age should be greater than 18",
    timeOfEmployment: "Time of Employment should be at least of 2 years",
    borrowerRequired: "At least 1 borrower is required",
    guarantorRequired: "At least 1 guarantor is required",
  },
  brandErrMsg: {
    emailAuthor: "Email author is required",
    smsAuthor: "SMS author is required",
    authenticationMethods: "Authentication methods are required",
  },
};
export const fieldEntityRequiredMessage = {
  city: "Address is required",
  entityAddress: "Address is required",
  entityName: "Entity is required",
  entityType: "Entity is required",
  abn: "Entity is required",
  industryType: "Industry type is required",
  turnover: "Turnover is required",
};

export const entityType = { soleTrader: "Individual/Sole Trader" };

export const entityStatus = {
  active: "Active",
  registered: "Registered",
};

export const validEntityStatus = [entityStatus.active, entityStatus.registered];

/** CreditorWatch checks an entity can run. The values match the server's `COMMERCIAL_CREDIT_CHECKS`. */
export const COMMERCIAL_CREDIT_CHECKS = {
  SCORE: "score",
  REPORT: "report",
} as const;

export type CommercialCreditCheck = (typeof COMMERCIAL_CREDIT_CHECKS)[keyof typeof COMMERCIAL_CREDIT_CHECKS];

/** Provider logos for the service cards. `height` is in px, sized so the logos read evenly side by side. */
export const SERVICE_PROVIDER_LOGOS = {
  asic: { src: "/static/asic-logo.png", alt: "ASIC", height: 44 },
  ppsr: { src: "/static/ppsr-logo.png", alt: "PPSR", height: 44 },
  equifax: { src: "/static/equifax-logo.png", alt: "Equifax", height: 16 },
  creditorWatch: { src: "/static/creditorwatch-logo.png", alt: "CreditorWatch", height: 20 },
};

/** The ASIC and Equifax checks an entity can run. The CreditorWatch ones are `COMMERCIAL_CREDIT_CHECKS`. */
export const ENTITY_SERVICE_CHECKS = {
  ASIC_EXTRACT: "asicExtract",
  ASIC_EXTRACT_PPSR: "asicExtractPpsr",
  EQUIFAX_REPORT: "equifaxReport",
  EQUIFAX_SCORED_REPORT: "equifaxScoredReport",
} as const;

export type EntityServiceCheck = (typeof ENTITY_SERVICE_CHECKS)[keyof typeof ENTITY_SERVICE_CHECKS];

export const ENTITY_SERVICE_CHECK_COPY: Record<
  EntityServiceCheck,
  { title: string; subtitle: string; loadingSubtitle: string }
> = {
  [ENTITY_SERVICE_CHECKS.ASIC_EXTRACT]: {
    title: "Get ASIC Extract",
    subtitle: "Retrieve the full extract, including directors and beneficial owners",
    loadingSubtitle: "Getting ASIC extract...",
  },
  [ENTITY_SERVICE_CHECKS.ASIC_EXTRACT_PPSR]: {
    title: "Get ASIC Extract & PPSR Data",
    subtitle: "Retrieve the full ASIC extract and PPSR data",
    loadingSubtitle: "Getting ASIC extract and PPSR data...",
  },
  [ENTITY_SERVICE_CHECKS.EQUIFAX_REPORT]: {
    title: "Get Company Credit Report",
    subtitle: "Retrieve a company credit report from Equifax",
    loadingSubtitle: "Getting company credit report...",
  },
  [ENTITY_SERVICE_CHECKS.EQUIFAX_SCORED_REPORT]: {
    title: "Get Scored Company Credit Report",
    subtitle: "Retrieve a company credit report with score from Equifax",
    loadingSubtitle: "Getting scored company credit report...",
  },
};

/** Card copy for each check. Both checks return a PDF, so the subtitle says so. */
export const COMMERCIAL_CREDIT_CHECK_COPY: Record<
  CommercialCreditCheck,
  { title: string; subtitle: string; loadingSubtitle: string; successMessage: string }
> = {
  [COMMERCIAL_CREDIT_CHECKS.SCORE]: {
    title: "Get Credit Report With Score",
    subtitle: "Retrieve the entity's credit score as a PDF",
    loadingSubtitle: "Getting credit score PDF...",
    successMessage: "Credit score PDF attached successfully.",
  },
  [COMMERCIAL_CREDIT_CHECKS.REPORT]: {
    title: "Get Credit Report",
    subtitle: "Retrieve the entity's full credit report as a PDF",
    loadingSubtitle: "Getting credit report PDF...",
    successMessage: "Credit report PDF attached successfully.",
  },
};

/** The values match the server's `EMPLOYMENT_INCOME_VERIFICATION_STATUS`. */
export const EMPLOYMENT_INCOME_VERIFICATION_STATUS = {
  PENDING: "pending",
  MATCHED: "matched",
  NO_MATCH: "no_match",
} as const;

export type EmploymentIncomeVerificationStatus =
  (typeof EMPLOYMENT_INCOME_VERIFICATION_STATUS)[keyof typeof EMPLOYMENT_INCOME_VERIFICATION_STATUS];

/** The values match the server's `EMPLOYMENT_INCOME_VERIFICATION_REPORT_PDF_STATUS`. */
export const EMPLOYMENT_INCOME_VERIFICATION_REPORT_PDF_STATUS = {
  ATTACHED: "attached",
  NOT_AVAILABLE: "not_available",
  FAILED: "failed",
} as const;

export type EmploymentIncomeVerificationReportPdfStatus =
  (typeof EMPLOYMENT_INCOME_VERIFICATION_REPORT_PDF_STATUS)[keyof typeof EMPLOYMENT_INCOME_VERIFICATION_REPORT_PDF_STATUS];

/** The periods a broker can order, in months. The server orders the matching Equifax product: M3, M12 or M36. */
export const EMPLOYMENT_INCOME_VERIFICATION_MONTHS = [3, 12, 36] as const;

export type EmploymentIncomeVerificationMonths = (typeof EMPLOYMENT_INCOME_VERIFICATION_MONTHS)[number];

export const EMPLOYMENT_INCOME_VERIFICATION_COPY = {
  sectionTitle: "Employment & Income Verification",
  monthsLabel: "Employment and income verification months",
  title: "Get Employment & Income Verification",
  subtitle: "Verify the customer's employment and income with Equifax",
  loadingSubtitle: "Verifying employment and income with Equifax...",
  successMessage: "Employment and income verification completed successfully.",
  noMatchMessage: "Equifax found no employment or income record for this customer.",
  noMatchHint: "Check the customer's name, date of birth and address, then try again.",
  reportPdfFailed: "The Equifax PDF report could not be attached. Our team has been notified.",
  requires: "Requires",
  missingFields: "Missing:",
  rejectedFields: "Check:",
  unnamedEmployer: "Employer name not provided",
} as const;

/** The details the server needs before it will order a verification. The keys match the field names it reports. */
export const EMPLOYMENT_INCOME_VERIFICATION_REQUIREMENT_LABELS = {
  firstName: "first name",
  lastName: "last name",
  dateOfBirth: "date of birth",
  idNumber: "licence or passport number",
  currentAddressPostcode: "current address postcode",
  privacyConsent: "signed privacy consent",
} as const;

export type EmploymentIncomeVerificationRequirement = keyof typeof EMPLOYMENT_INCOME_VERIFICATION_REQUIREMENT_LABELS;

/**
 * Names for the fields a refused verification reports: the details the server found missing (`missingFields`) and the
 * request fields Equifax rejected (`invalidFields`), looked up without list indexes, then by their first segment.
 */
export const EMPLOYMENT_INCOME_VERIFICATION_FIELD_LABELS: Record<string, string> = {
  ...EMPLOYMENT_INCOME_VERIFICATION_REQUIREMENT_LABELS,
  brokerEmail: "your email address",
  brokerName: "your name",
  middleName: "middle name",
  dob: "date of birth",
  emailAddress: "email address",
  phoneNumber: "phone number",
  employeeAddress: "current address",
  "employeeAddress.postalCode": "current address postcode",
  previousAddresses: "previous addresses",
  employmentHistoryInformation: "employment history",
  brokerId: "your email address",
};

/** The Equifax documents the employment and income verification terms and consent name, linked where they are named. */
export const EMPLOYMENT_INCOME_VERIFICATION_DOCUMENTS = {
  brokerServiceTerms: {
    label: "Equifax Verification Exchange® Broker Service Terms",
    href: "https://www.equifax.com.au/verificationexchange/sites/default/files/Broker-Service-Terms.pdf",
  },
  collectionStatement: {
    label: "Verification Exchange Collection Statement",
    href: "https://www.equifax.com.au/hrsolutions/pdf/ve-collection-statement.pdf",
  },
} as const;

/** Asked once, together, before the broker's first verification: the customer consent, then Equifax's terms. */
export const EMPLOYMENT_INCOME_VERIFICATION_MODAL_STEPS = {
  CONSENT: "consent",
  TERMS: "terms",
} as const;

export type EmploymentIncomeVerificationModalStep =
  (typeof EMPLOYMENT_INCOME_VERIFICATION_MODAL_STEPS)[keyof typeof EMPLOYMENT_INCOME_VERIFICATION_MODAL_STEPS];

/** The terms name this button ("By clicking Accept"), so the text and the button share it. */
const EMPLOYMENT_INCOME_VERIFICATION_ACCEPT_TERMS = "Accept";

/** Equifax's wording, word for word, with the documents it names in place as links. */
export const EMPLOYMENT_INCOME_VERIFICATION_MODAL_COPY = {
  cancel: "Cancel",
  consent: {
    stepLabel: "Confirm consent",
    title: "Applicant consent",
    intro:
      "Before calling the Verification Exchange for any applicant, every applicant must consent to the service. Therefore, the below Verification Exchange Collection Statement must be included in the signed Privacy Consent Agreement of the applicant. Please add the following statement to your Privacy Consent Agreement:",
    /** In the applicant's voice, as the broker adds it to their Privacy Consent Agreement. */
    statement: {
      intro:
        "So that my application can be assessed, as relevant, I consent to you and your service provider, Equifax Verification Exchange® (and/or, my prospective lender and Equifax Verification Exchange® as its service provider) collecting, using and disclosing:",
      items: [
        "to my employers (or to payroll or other service providers who might act on behalf of my employers), my personal information to identify me; and",
        "my employment income, history and related information obtained from such parties to allow you (or that other party, as relevant) to verify those matters.",
      ],
      closing: [
        "I consent to Equifax Verification Exchange® using and disclosing my personal information in accordance with its ",
        EMPLOYMENT_INCOME_VERIFICATION_DOCUMENTS.collectionStatement,
        ".",
      ],
    },
    copyStatement: "Copy statement",
    privacyConsentConfirmation:
      "I confirm that I have included the above Verification Exchange Collection Statement in my Privacy Consent Agreement.",
    confirm: "Confirm",
  },
  terms: {
    stepLabel: "Accept terms",
    title: "Broker service terms",
    paragraphs: [
      [
        "Equifax provides Equifax Verification Exchange® Verification Services to brokers in accordance with the terms and conditions set out in the ",
        EMPLOYMENT_INCOME_VERIFICATION_DOCUMENTS.brokerServiceTerms,
        " incorporating the Equifax Verification Exchange® Privacy Collection Notice and the Equifax HR Solutions Privacy Policy.",
      ],
      [
        `By clicking ${EMPLOYMENT_INCOME_VERIFICATION_ACCEPT_TERMS} I acknowledge that I have read, understood and agree to the `,
        EMPLOYMENT_INCOME_VERIFICATION_DOCUMENTS.brokerServiceTerms,
        " (incorporating the Collection Notice and Privacy Policy) of Equifax Verification Exchange® Verification Services.",
      ],
    ],
    accept: EMPLOYMENT_INCOME_VERIFICATION_ACCEPT_TERMS,
  },
} as const;

export const creditCardModalInfo = {
  mainTitle: "Looks like you've not added a Credit card.",
  subTitle: "Click on the link below to add your Credit card.",
  btnText: "Add Credit card",
};

export const payInvoiceModalInfo = {
  mainTitle: "Looks like you've pending Invoice",
  SubTitle: "Click on the link below to check your pending Invoice",
  btnText: "View Invoice",
};

export const completedLender = ["Pepper"];

export const STATUS_CODE = { success: 200 };

export const APPLICATION_STATUS_LABEL = {
  Workshop: "Workshop",
  InProgress: "In Progress",
  PendingInformation: "Pending Information",
  Submitted: "Submitted",
  Withdrawn: "Withdrawn",
  Approved: "Approved",
  Declined: "Declined",
  DocsIssued: "Docs Issued",
  Settled: "Settled",
};

export const APPLICATION_STATUS = Object.values(APPLICATION_STATUS_LABEL).map((status) => ({
  label: status,
  value: status,
}));

export const VITE_WORKOS_AUTHKIT_DOMAIN = import.meta.env.VITE_WORKOS_AUTHKIT_DOMAIN;
export const VITE_SELF_HOSTED_AUTH_ENABLED = import.meta.env.VITE_SELF_HOSTED_AUTH_ENABLED;

export const ID_TYPE = {
  LICENCE: "Licence",
  PASSPORT: "Passport",
};

export const ROLE_NAMES = {
  USER: "user",
  ADMIN: "admin",
  SUPPORT: "support",
  MASTER: "master",
  OWNER: "owner",
  USER_REFERRER: "user-referrer",
  MASTER_REFERRER: "master-referrer",
  OWNER_REFERRER: "owner-referrer",
};
export const lenderListWith2FA = ["AFS", "Angle Finance", "resimac"]; // "NOW"

export const privacyDocsNameList = [
  "Privacy agreement",
  "SIGNED Privacy Consent - Asset Finance.pdf",
  "SIGNED Credit Guide and Privacy Consent - Consumer Asset Finance and Personal Loans.pdf",
];

export const usedDocsNames = [
  "Driver licence (back)",
  "Driver licence (front)",
  "Customer photo",
  "Verification certificate",
  "ID document",
  "Bank statements",
  "Credit file",
  "Illion Credit file",
  "No record credit file",
  "No record illion credit file",
  // Shown in the customer's Employment & Income Verification section.
  "Employment and income verification",
  ...privacyDocsNameList,
];

export const YES_NO_OPTIONS = [
  { icon: "House", label: "Yes" },
  { icon: "HomeWork", label: "No" },
];

export const REPAYMENT_METHOD_OPTIONS = [
  { icon: "House", label: "In Advance" },
  { icon: "HomeWork", label: "In Arrears" },
];

export const entityTypeList = [
  "Individual/Sole Trader",
  "Australian Private Company",
  "Australian Public Company",
  "Cash Management Trust",
  "Corporate Unit Trust",
  "Discretionary Investment Trust",
  "Discretionary Services Management Trust",
  "Discretionary Trading Trust",
  "First Home Saver Accounts (FHSA) Trust",
  "Fixed Trust",
  "Fixed Unit Trust",
  "Hybrid Trust",
  "Listed Public Unit Trust",
  "Other Trust",
  "Pooled Superannuation Trust",
  "Public Trading Trust",
  "Unlisted Public Unit Trust",
  "Family Partnership",
  "Limited Partnership",
  "Other Partnership",
];

export const MESSAGE_TYPE = {
  EMAIL: "email",
  SMS: "sms",
  DOCUMENT: "document",
};

export const emailTemplatePath = "/settings/templates/email";
export const smsTemplatePath = "/settings/templates/sms";
export const documentTemplatePath = "/settings/templates/document";

export const SIGNATURE_TYPE = {
  PRIVACY: "privacy",
  DISCLOSURE: "disclosure",
};

export const HEM_CONSTANTS = [
  {
    minIncome: 0,
    maxIncome: 1975.6,
    coupleRate: 2407,
    coupleWithChildren: {
      1: 2805,
      2: 3115,
      3: 3456,
    },
    singleRate: 1269,
    singleWithChildren: {
      1: 1731,
      2: 2207,
      3: 2682,
    },
    additionalChild: 341,
  },
  {
    minIncome: 1975.61,
    maxIncome: 2853.1,
    coupleRate: 2459,
    coupleWithChildren: {
      1: 2858,
      2: 3167,
      3: 3509,
    },
    singleRate: 1322,
    singleWithChildren: {
      1: 1784,
      2: 2259,
      3: 2735,
    },
    additionalChild: 341,
  },
  {
    minIncome: 2853.11,
    maxIncome: 3606.86,
    coupleRate: 2533,
    coupleWithChildren: {
      1: 2931,
      2: 3241,
      3: 3582,
    },
    singleRate: 1395,
    singleWithChildren: {
      1: 1857,
      2: 2333,
      3: 2808,
    },
    additionalChild: 341,
  },
  {
    minIncome: 3606.87,
    maxIncome: 4338.11,
    coupleRate: 2621,
    coupleWithChildren: {
      1: 3019,
      2: 3330,
      3: 3671,
    },
    singleRate: 1483,
    singleWithChildren: {
      1: 1945,
      2: 2421,
      3: 2896,
    },
    additionalChild: 341,
  },
  {
    minIncome: 4338.12,
    maxIncome: 5013.11,
    coupleRate: 2786,
    coupleWithChildren: {
      1: 3185,
      2: 3496,
      3: 3839,
    },
    singleRate: 1647,
    singleWithChildren: {
      1: 2110,
      2: 2586,
      3: 3061,
    },
    additionalChild: 343,
  },
  {
    minIncome: 5013.12,
    maxIncome: 6419.36,
    coupleRate: 3032,
    coupleWithChildren: {
      1: 3433,
      2: 3744,
      3: 4090,
    },
    singleRate: 1892,
    singleWithChildren: {
      1: 2357,
      2: 2832,
      3: 3307,
    },
    additionalChild: 345,
  },
  {
    minIncome: 6419.37,
    maxIncome: 7806.86,
    coupleRate: 3384,
    coupleWithChildren: {
      1: 3787,
      2: 4099,
      3: 4448,
    },
    singleRate: 2242,
    singleWithChildren: {
      1: 2709,
      2: 3184,
      3: 3659,
    },
    additionalChild: 349,
  },
  {
    minIncome: 7806.87,
    maxIncome: 9119.36,
    coupleRate: 3688,
    coupleWithChildren: {
      1: 4092,
      2: 4405,
      3: 4757,
    },
    singleRate: 2543,
    singleWithChildren: {
      1: 3012,
      2: 3487,
      3: 3961,
    },
    additionalChild: 352,
  },
  {
    minIncome: 9119.37,
    maxIncome: 10431.86,
    coupleRate: 4071,
    coupleWithChildren: {
      1: 4477,
      2: 4791,
      3: 5147,
    },
    singleRate: 2924,
    singleWithChildren: {
      1: 3395,
      2: 3870,
      3: 4344,
    },
    additionalChild: 356,
  },
  {
    minIncome: 10431.87,
    maxIncome: 11611.04,
    coupleRate: 4265,
    coupleWithChildren: {
      1: 4673,
      2: 4987,
      3: 5345,
    },
    singleRate: 3117,
    singleWithChildren: {
      1: 3590,
      2: 4064,
      3: 4538,
    },
    additionalChild: 358,
  },
  {
    minIncome: 11611.05,
    maxIncome: 13948.54,
    coupleRate: 4457,
    coupleWithChildren: {
      1: 4866,
      2: 5181,
      3: 5540,
    },
    singleRate: 3308,
    singleWithChildren: {
      1: 3782,
      2: 4256,
      3: 4730,
    },
    additionalChild: 360,
  },
  {
    minIncome: 13948.55,
    maxIncome: 16790.2,
    coupleRate: 4984,
    coupleWithChildren: {
      1: 5396,
      2: 5712,
      3: 6076,
    },
    singleRate: 3832,
    singleWithChildren: {
      1: 4309,
      2: 4783,
      3: 5256,
    },
    additionalChild: 365,
  },
  {
    minIncome: 16790.21,
    maxIncome: 19677.7,
    coupleRate: 5476,
    coupleWithChildren: {
      1: 5891,
      2: 6208,
      3: 6578,
    },
    singleRate: 4321,
    singleWithChildren: {
      1: 4802,
      2: 5274,
      3: 5747,
    },
    additionalChild: 370,
  },
  {
    minIncome: 19677.71,
    maxIncome: 31136.04,
    coupleRate: 5760,
    coupleWithChildren: {
      1: 6176,
      2: 6494,
      3: 6866,
    },
    singleRate: 4603,
    singleWithChildren: {
      1: 5085,
      2: 5558,
      3: 6031,
    },
    additionalChild: 373,
  },
  {
    minIncome: 31136.05,
    maxIncome: 45857777.75,
    coupleRate: 6018,
    coupleWithChildren: {
      1: 6435,
      2: 6754,
      3: 7128,
    },
    singleRate: 4859,
    singleWithChildren: {
      1: 5343,
      2: 5815,
      3: 6288,
    },
    additionalChild: 375,
  },
];

export const PERMISSION_TAB = {
  APPLICATIONS: "Applications",
  SERVICES: "Services",
  ORGANISATIONS: "Organisations",
  USERS: "Users",
  TEMPLATES: "Templates",
  LENDERS: "Lenders",
  COMMISSION: "Commission",
};

export const tabList = [
  PERMISSION_TAB.APPLICATIONS,
  PERMISSION_TAB.SERVICES,
  PERMISSION_TAB.ORGANISATIONS,
  PERMISSION_TAB.USERS,
  PERMISSION_TAB.TEMPLATES,
  PERMISSION_TAB.LENDERS,
  PERMISSION_TAB.COMMISSION,
];

export const userFilter = {
  ACTIVE: "Active",
  INVITED: "Invited",
};

export const userStatusList = ["Pending", "Approved", "Live", "Declined"];

export const emailTemplateEditorConfig = {
  toolbar: [
    ["bold", "italic", "underline", "strike"], // toggled buttons
    ["blockquote", "code-block"],
    [
      "link",
      // "image",
      // "video",
      // "formula" // Requires KaTex library
    ],

    [{ header: 1 }, { header: 2 }], // custom button values
    [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
    [{ script: "sub" }, { script: "super" }], // superscript/subscript
    [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
    [{ direction: "rtl" }], // text direction

    // [{ size: ["small", false, "large", "huge"] }], // custom dropdown
    [{ header: [1, 2, 3, 4, 5, 6, false] }],

    [{ color: [] }, { background: [] }], // dropdown with defaults from theme
    // [{ font: [] }],
    [{ align: [] }],

    ["clean"], // remove formatting button
  ],
  formats: true,
};

export const smsTemplateEditorConfig = {
  toolbar: false,
  formats: false, // Disable formatting operations
};
export const customerProfileRequiredFields = [
  "residencyStatus",
  "maritalStatus",
  "contactNumber",
  "rentAmount",
  "industry",
  "livingArrangements",
  "shareOfExpenses",
  "numberOfDependants",
];

export const envVariables = {
  VITE_NODE_ENV: import.meta.env.VITE_NODE_ENV,
  VITE_PUBLIC_URL: import.meta.env.VITE_PUBLIC_URL,
  VITE_INTERCOM_APP_ID: import.meta.env.VITE_INTERCOM_APP_ID,
  VITE_PUBLIC_POSTHOG_KEY: import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
  VITE_PUBLIC_POSTHOG_HOST: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  VITE_AUTH0_ISSUER_BASE_URL: import.meta.env.VITE_AUTH0_ISSUER_BASE_URL,
  VITE_AUTH0_CLIENT_ID: import.meta.env.VITE_AUTH0_CLIENT_ID,
  VITE_AUTH0_REDIRECT_URI: import.meta.env.VITE_AUTH0_REDIRECT_URI,
  VITE_PUBLIC_INTERCOM_APP_ID: import.meta.env.VITE_PUBLIC_INTERCOM_APP_ID,
  VITE_LOGOUT_URL: import.meta.env.VITE_LOGOUT_URL,
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_HONEYCOMB_API_KEY: import.meta.env.VITE_HONEYCOMB_API_KEY,
  VITE_HONEYCOMB_SERVICE_NAME: import.meta.env.VITE_HONEYCOMB_SERVICE_NAME,
  VITE_ADMIN_LENDER_URL: import.meta.env.VITE_ADMIN_LENDER_URL,
  VITE_LENDER_URL: import.meta.env.VITE_LENDER_URL,
  VITE_FORM_DATA_DETAILS_URL: import.meta.env.VITE_FORM_DATA_DETAILS_URL,
  VITE_APPLICATION_FILE_UPLOAD_URL: import.meta.env.VITE_APPLICATION_FILE_UPLOAD_URL,
  VITE_USER_APPLICATION_ID_URL: import.meta.env.VITE_USER_APPLICATION_ID_URL,
  VITE_CLIENT_ID: import.meta.env.VITE_CLIENT_ID,
  VITE_CDN_URL: import.meta.env.VITE_CDN_URL,
  VITE_STRIPE_SECRET: import.meta.env.VITE_STRIPE_SECRET,
  VITE_STRIPE_SECRET_KEY: import.meta.env.VITE_STRIPE_SECRET_KEY,
  VITE_STRIPE_PUBLISH_KEY: import.meta.env.VITE_STRIPE_PUBLISH_KEY,
  VITE_UNAUTHORIZED_REDIRECT: import.meta.env.VITE_UNAUTHORIZED_REDIRECT,
  VITE_WORKOS_CLIENT_ID: import.meta.env.VITE_WORKOS_CLIENT_ID,
  VITE_WORKOS_AUTHKIT_DOMAIN: import.meta.env.VITE_WORKOS_AUTHKIT_DOMAIN,
  VITE_SELF_HOSTED_AUTH_ENABLED: import.meta.env.VITE_SELF_HOSTED_AUTH_ENABLED,
  VITE_ALLOWED_LENDER_LIST: import.meta.env.VITE_ALLOWED_LENDER_LIST,
  VITE_ANNOUNCE_KIT_WIDGET: import.meta.env.VITE_ANNOUNCE_KIT_WIDGET,
  VITE_ENV: import.meta.env.VITE_ENV,
  VITE_SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
  VITE_SENTRY_ENVIRONMENT: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  VITE_SENTRY_ORGANIZATION: import.meta.env.VITE_SENTRY_ORGANIZATION,
  VITE_SENTRY_PROJECT_ID: import.meta.env.VITE_SENTRY_PROJECT_ID,
  VITE_ABR_TOKEN: import.meta.env.VITE_ABR_TOKEN,
  VITE_LODGEAI_NATIVE_OTA_URL: import.meta.env.VITE_LODGEAI_NATIVE_OTA_URL,
};

export const dateFormat = "dd-MM-yyyy";

export const readableDateFormat = "DD-MM-YYYY";

export const isoDateFormat = "YYYY-MM-DD";

export const publicRoutes = [
  "/auth",
  "/sign-in",
  "/privacy",
  "/disclosure",
  "/contact-details",
  "/customer-documents-upload",
  "/asset-documents-upload",
  "/status",
];

export const ROUTES = {
  ROOT: "/",
  CUSTOMER_UPLOAD_DOCUMENTS: "/customer-documents-upload",
  ASSET_UPLOAD_DOCUMENTS: "/asset-documents-upload",
  CONTACT_DETAILS: "/contact-details",
  PRIVACY: "/privacy",
  DISCLOSURE: "/disclosure",
  SIGN_IN: "/sign-in",
  STATUS: "/status",
  NOT_FOUND: "/404",
  APPLICATIONS_FULL: "/applications",
  AUTH: {
    ROOT: "/auth",
    SIGN_IN: "sign-in",
    SIGN_IN_FULL: "/auth/sign-in",
    MAGIC: "magic",
    MFA: "mfa",
    MFA_ENROLMENT: "mfa-enrolment",
    VERIFY_EMAIL: "verify-email",
    RESET_PASSWORD: "reset-password",
    SELECT_ORGANISATION: "select-organisation",
    INVITE: {
      ROOT: "invite",
      SET_NAME: "set-name",
      SET_PASSWORD: "set-password",
      SET_MFA: "set-mfa",
      ACCEPT: "accept",
    },
  },
  APP: {
    CONTACT_DETAILS: "contact-details",
    NOT_FOUND: "404",
    TERMS_AND_CONDITIONS: "terms-and-conditions",
    INVITE_USERS: "invite-users",
    QUOTES: "quotes",
    QUOTE_DETAIL: "quote/:applicationId",
    INVITE_USER: "invite/:userId",
    APPLICATIONS: "applications",
    APPLICATION_DETAIL: "application/:applicationId",
    ORGANISATION: "organisation",
    ORGANISATION_NEW: "organisation/new",
    ORGANISATION_DETAIL: "organisation/:orgId",
    ORGANISATION_ROLE_PERMISSIONS: "organisation/rolepermissions/:organisationId",
    USERS: "users",
    CALCULATOR: "calculator",
    CALCULATOR_DETAIL: "calculator/:applicationId",
    USER_ROLE_PERMISSIONS: "user/rolepermissions/:userId",
    SETTINGS: "settings",
    SETTINGS_TEMPLATE: ":path/:messageType/:templateId",
    SETTINGS_PATH: ":path/*",
    BILLING: "billing",
    BILLING_PATH: "billing/:path",
    REPORTING: "reporting/:path",
    WILDCARD: "*",
  },
  REPORTING: {
    ROOT: "/reporting",
    COMMISSION: "/reporting/commission",
    APPLICATIONS_DATA: "/reporting/applications-data",
  },
  ADMIN: {
    ROOT: "/admin",
    TENANTS: "/admin/tenants",
    TENANT_DETAIL: "/admin/tenant/:tenantId",
    SERVICES: "/admin/services",
    SERVICE_DETAIL: "/admin/service/:serviceId",
    SERVICE_USAGES: "/admin/service-usages",
    SERVICE_USAGE_DETAIL: "/admin/service-usage/:serviceUsageId",
    INVOICES: "/admin/invoices",
    INVOICE_CREATE: "/admin/invoice/new",
    INVOICE_DETAIL: "/admin/invoice/:invoiceId",
  },
} as const;

export enum BrandedOrganisation {
  GGF = "ggf",
}

export const brandedOrganisations: BrandedOrganisation[] = [BrandedOrganisation.GGF];

export const professionalServicesList = [
  "Specialist Medical Services",
  "Specialist Dental Services",
  "General Practice Medical Services",
  "Hospital",
  "Dentist Services",
  "Veterinary Services",
  "Chiropractor",
  "Dental Technician",
  "Medical Radiation Therapist",
  "Occupational Therapist",
  "Optometrist",
  "Osteopath",
  "Pharmacist",
  "Physiotherapist",
  "Podiatrist",
  "Psychologist",
  "Radiographers",
  "Medical Doctor",
  "Surgeon",
  "Medical Specialist",
  "Dentist",
  "Veterinarian",
  "Ophthalmologist",
  "Lawyer",
  "Barrister",
  "Judge",
  "Solicitor",
  "Accountant",
  "Surveyor",
  "Architect",
  "Psychiatrist",
  "Engineer",
];

export enum ApplicationAssetSections {
  INVOICE = "invoice",
  DEAL_DETAILS = "dealDetails",
  VEHICLE_SEARCH = "vehicleSearch",
  GLASS_GUIDE = "glassGuide",
  ODOMETER = "odometer",
  ADDONS = "addons",
  SUPPLIER = "supplier",
  INSURANCE_QUOTE = "insuranceQuote",
  PPSR_DETAILS = "ppsrDetails",
  ASSET_DETAILS = "assetDetails",
}

export const ApplicationAssetSectionsList = [
  { id: ApplicationAssetSections.ASSET_DETAILS, title: "Details" },
  { id: ApplicationAssetSections.ODOMETER, title: "Odometer | Serial Number" },
  { id: ApplicationAssetSections.ADDONS, title: "Add-ons" },
  { id: ApplicationAssetSections.INVOICE, title: "Invoice" },
  { id: ApplicationAssetSections.SUPPLIER, title: "Supplier" },
  { id: ApplicationAssetSections.INSURANCE_QUOTE, title: "Insurance Quote" },
];

/** Sections every asset starts with expanded. */
export const DEFAULT_EXPANDED_ASSET_SECTIONS = [ApplicationAssetSections.ADDONS];

export const SECTION_TYPE = {
  DOCUMENT_TEMPLATE: "documentTemplate",
  ASSET_INVOICE: "assetInvoice",
};

export const FILE_ACCEPTANCE_TYPES = {
  [SECTION_TYPE.DOCUMENT_TEMPLATE]: {
    "application/msword": [".doc"],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
  },
  [SECTION_TYPE.ASSET_INVOICE]: {
    "application/pdf": [".pdf"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
  },
};

/** Shown under "Uploaded File" on a document template until a file has been uploaded. */
export const DOCUMENT_TEMPLATE_EMPTY_STATE = {
  TITLE: "No file uploaded yet",
  DESCRIPTION: "Upload your template file above and it will appear here.",
} as const;

export const searchableAssets = [
  "Motor Vehicle (<4.5 tonnes)",
  "Electric Motor Vehicle (<4.5 tonnes)",
  "Commercial (Small to Medium) Vehicles (<12 Tonnes)",
  "Commercial (Heavy) Vehicles (>12 Tonnes)",
  "Mini Buses & Route Buses (<25 seats)",
  "Motorbikes, ATVs",
  "Trailer",
  "Trailers (car)",
  "Trailers (truck)",
  "Caravan",
  "Classic car",
  "Motor Vehicle",
  "Electric Motor Vehicle",
  "Luxury Vehicle",
  "Motorbike",
  "Motorbike (Off Road)",
  "ATV",
];

/** Vehicle-data providers behind the asset lookup cascade. The server picks one per tenant. */
export const ASSET_LOOKUP_PROVIDERS = {
  GLASSES: "GLASSES",
  AUTOGRAB: "AUTOGRAB",
} as const;

export type AssetLookupProvider = (typeof ASSET_LOOKUP_PROVIDERS)[keyof typeof ASSET_LOOKUP_PROVIDERS];

const ASSET_LOOKUP_PROVIDER_NAMES: Record<string, string> = {
  [ASSET_LOOKUP_PROVIDERS.GLASSES]: "Glass's Guide",
  [ASSET_LOOKUP_PROVIDERS.AUTOGRAB]: "AutoGrab",
};

export const getAssetLookupProviderName = (provider?: string) =>
  ASSET_LOOKUP_PROVIDER_NAMES[provider ?? ""] ?? ASSET_LOOKUP_PROVIDER_NAMES[ASSET_LOOKUP_PROVIDERS.GLASSES];

/** The options are peers — any one fills in the whole asset, so they are not numbered. */
export const ASSET_SEARCH_OPTIONS = {
  MAKE_MODEL_HEADING: "Search via dropdown",
  /** Plain text leading into the manual toggle; only the toggle itself is the link. */
  MANUAL_PROMPT: "Can't find it?",
  MANUAL_TOGGLE: "Add asset details manually",
  LOOKUP_TOGGLE: "Use vehicle search instead",
  LOADING: "Loading search options...",
} as const;

const ASSET_SEARCH_OPTION_COUNT_WORDS: Record<number, string> = { 2: "two", 3: "three" };

/** Split so "one" can be emphasised, and so the count follows however many options rendered. */
export const getAssetSearchOptionsIntro = (count: number) => ({
  LEAD: "Use any",
  EMPHASIS: "one",
  TRAIL: `of these ${ASSET_SEARCH_OPTION_COUNT_WORDS[count] ?? count} options to find the asset.`,
});

export const PPSR_CERTIFICATE_DOCUMENT_NAME = "PPSR Certificate";

export const VEHICLE_LOOKUP_SEARCH = {
  HEADING: "Search by registration no. or VIN",
  VEHICLE_BUTTON: "Search vehicle",
  PPSR_BUTTON: "Get PPSR report",
  REQUIRES_IDENTIFIER: "Enter a VIN, or a registration no. and state",
  REQUIRES_STATE: "Select the rego. state",
} as const;

/** Shortest query the picker accepts; fewer characters match most of the catalogue and rank badly. */
const PLAIN_TEXT_VEHICLE_SEARCH_MIN_LENGTH = 10;

/** Free-text vehicle search. AutoGrab tenants only — Glass's Guide cannot answer a bare keyword. */
export const PLAIN_TEXT_VEHICLE_SEARCH = {
  MIN_LENGTH: PLAIN_TEXT_VEHICLE_SEARCH_MIN_LENGTH,
  /** Long enough to sit through the pause between words, without a request per word typed. */
  DEBOUNCE_MS: 800,
  HEADING: "Search by description",
  LABEL: "Vehicle description",
  PLACEHOLDER: "e.g. 2021 Toyota HiLux SR5 dual cab",
  HINT: `Type at least ${PLAIN_TEXT_VEHICLE_SEARCH_MIN_LENGTH} characters — year, make, model and badge in any order`,
  SEARCHING: "Searching matching vehicles",
  NO_RESULTS: "No matching vehicles. Try fewer words, or use the fields below.",
  SEARCH_FAILED: "Couldn't complete that search. Try the year, make and model, or use the fields below.",
  RESOLVING: "Loading the vehicle's details",
} as const;

/** The panel frame is shared between providers. */
export const ASSET_DETAILS_PANEL = {
  GLASSES_HEADING: "Glass Guide Specifications",
  /** The specification panel reads the same whichever provider identified the vehicle. */
  DEFAULT_SPECIFICATION_HEADING: "Vehicle Specifications",
  PPSR_HEADING: "PPSR Details & Documents",
  VALUATION_HEADING: "Valuation",
  VEHICLE_HEADING: "Vehicle",
} as const;

/** AutoGrab prices with a range around its estimate, so retail and trade each take two rows. */
export const ASSET_SPECIFICATION_VALUATION = {
  ESTIMATED_LVR: "Estimated LVR",
  RETAIL: "Retail",
  RETAIL_RANGE: "Retail Range",
  TRADE: "Trade",
  TRADE_RANGE: "Trade Range",
  RRP: "RRP",
  /** The odometer the valuation was struck at, not the asset's own odometer. */
  VALUATION_KMS: "Valuation Kms",
} as const;

/**
 * Specification rows in display order; a row is skipped when the payload has nothing for it. `keys`
 * is tried in order because the payload carries Glass's-style aliases beside AutoGrab's own names.
 */
export const ASSET_SPECIFICATION_FIELDS: { keys: string[]; label: string; suffix?: string }[] = [
  { keys: ["BodyType", "BodyName"], label: "Body" },
  { keys: ["Transmission", "TransmissionName"], label: "Transmission" },
  { keys: ["Gears"], label: "Gears" },
  { keys: ["FuelType", "FuelName"], label: "Fuel Type" },
  { keys: ["EngineType", "EngineName"], label: "Engine" },
  { keys: ["EngineCapacity", "CCName"], label: "Engine Capacity", suffix: " cc" },
  { keys: ["Cylinders"], label: "Cylinders" },
  { keys: ["PowerKW", "KW"], label: "Power", suffix: " kW" },
  { keys: ["TorqueNM", "Torque"], label: "Torque", suffix: " Nm" },
  { keys: ["DriveType", "DrivenWheelsName"], label: "Drive Type" },
  { keys: ["NoOfDoors", "Doors"], label: "Doors" },
  { keys: ["NoOfSeats", "Seats"], label: "Seats" },
  { keys: ["ModelYear"], label: "Model Year" },
];

export const INSURANCE_QUOTE_TO = {
  CUSTOMER: "customer",
  BROKER: "broker",
};

export const APPLICATION_SECTIONS_ID = {
  ASSETS: "assets",
  CUSTOMERS: "customers",
  ENTITIES: "entities",
  LOAN_DETAILS: "loanDetails",
  INTRODUCER_DECLARATION: "introducerDeclaration",
  NCCP_DECLARATION: "nccpDeclaration",
  LOAN_SUMMARY: "loanSummaryDemo", // just for demo purpose only
};

export const APPLICATION_FOLLOWER_ROLES = {
  VIEW: "view",
  EDIT: "edit",
};

export const DOCUMENT_TEMPLATE_TYPE = {
  CUSTOMER_PRIVACY_CONSUMER: "CustomerPrivacyConsumer",
  CUSTOMER_PRIVACY_COMMERCIAL: "CustomerPrivacyCommercial",
  CUSTOMER_DISCLOSURE: "CustomerDisclosure",
  LENDER_PRODUCTS_QUOTE_DOCUMENT: "LenderProductsQuoteDocument",
};

export const PLANT_AND_EQUIPMENT_INSURANCE_ASSETS = [
  "Earth Moving & Construction (wheeled or tracked)",
  "Agricultural & Landscaping Equipment (wheeled or tracked)",
  "Warehouse Equipment (wheeled or tracked)",
  "Industrial Plant & Printing",
  "Manufacturing Equipment",
  "ATV",
];

export const MOTOR_INSURANCE_ASSETS = [
  "Commercial (Small to Medium) Vehicles (<12 Tonnes)",
  "Commercial (Heavy) Vehicles (>12 Tonnes)",
  "Prime Mover",
  "Mini Buses & Route Buses (<25 seats)",
];

export const INSURANCE_QUOTE_ASSETS = [...PLANT_AND_EQUIPMENT_INSURANCE_ASSETS, ...MOTOR_INSURANCE_ASSETS];

export const SHARES_TYPES = {
  ALL: "all",
  INDIVIDUALLY: "individually",
};

export const SHARE_OF_DISABLED_TOOLTIP =
  'Serviceability is set to "All": Switch Expense & liability share type to "Individually" there to edit this percentage for each item.';

export const MARITAL_STATUSES = {
  MARRIED_DEFACTO: "Married/Defacto",
  SINGLE_DIVORCED_WIDOWED: "Single/Divorced/Widowed",
};

export const RENT_EXPENSE_TYPE = "Rent";

/** Income type that is shaded — only a percentage of the amount counts towards serviceability. */
export const INVESTMENT_PROPERTY_INCOME_TYPE = "Investment property";

/** Liability type that carries a repayment buffer calculated from its credit limit. */
export const CREDIT_CARD_LIABILITY_TYPE = "Credit card";

/** Slider marks shared by the share of expenses and HEM split sliders (values are fractions of 1). */
export const SHARE_SLIDER_MARKS = [
  { value: 0, label: "0%" },
  { value: 0.25, label: "25%" },
  { value: 0.5, label: "50%" },
  { value: 0.75, label: "75%" },
  { value: 1, label: "100%" },
];

/** Comment a broker records against the applicant's serviceability. Stored on the customer profile. */
export const SERVICEABILITY_COMMENT = {
  fieldName: "serviceabilityComment",
  placeholder: "Add any comment about this applicant's serviceability",
  maxLength: 1000,
  minRows: 3,
};

export const APPLICATION_DOWNLOAD_TYPE = {
  PDF: "pdf",
  EXCEL: "excel",
};

export const TENANT_TYPES = {
  broker: "broker",
  lender: "lender",
};

export const TENANT_STATUS = {
  active: "active",
  inactive: "inactive",
};

export const SERVICE_TYPES = {
  free: "free",
  paid: "paid",
};

export const INVOICE_STATUS = {
  draft: "draft",
  open: "open",
  overdue: "overdue",
  paid: "paid",
};

export const INVOICE_TYPES = {
  custom: "custom",
  auto: "auto",
};

export const INVOICE_FEES_TYPES = {
  licenceFee: "Licence fee",
  referralFee: "Referral fee",
  customFee: "Custom fee",
};

export const INVOICE_LOCKED_CC_EMAIL = "billing@financeable.com.au";
export const INVOICE_GST_RATE = 0.1;
export const INVOICE_CURRENCY = "AUD";

export const INVOICE_BILLING_MONTHS: { label: string; value: number }[] = [
  { label: "January", value: 1 },
  { label: "February", value: 2 },
  { label: "March", value: 3 },
  { label: "April", value: 4 },
  { label: "May", value: 5 },
  { label: "June", value: 6 },
  { label: "July", value: 7 },
  { label: "August", value: 8 },
  { label: "September", value: 9 },
  { label: "October", value: 10 },
  { label: "November", value: 11 },
  { label: "December", value: 12 },
];

export const DEFAULT_SORT_FIELD = { field: "createdAt", sort: "desc" };

export const INVOICE_SECTIONS = {
  invoiceInfo: "Invoice info",
  recipient: "Recipient",
  feesItems: "Fees items",
  serviceUsages: "Service usages",
  invoiceNotes: "Invoice notes",
  emailPreview: "Email preview",
  summary: "Summary",
};

export const TOOLTIP_MESSAGES = {
  CREDIT_PROFILE_SCORE_TOGGLE:
    "Toggle to select which score, manual or Equifax, to evaluate in the lender products criteria.",
  SEND_QUOTES_UPLOAD_TEMPLATE:
    "To send quotes, upload a Lender Product Quotes document template (Word file) from the Templates section.",
  SEND_QUOTES_SELECT_QUOTE: "Select at least one quote to send.",
  SEND_QUOTES_SELECT_QUOTE_LIMIT: "Select up to 3 quotes to send.",
  SEND_QUOTES_SELECT_CUSTOMER: "Select at least one customer to send the quotes to.",
  SEND_QUOTE_ADD_CUSTOMER_EMAIL: "Add a customer email address to send the quote.",
  NO_CUSTOMER_EMAIL_FOR_SEND_QUOTE: "No customers with email available.",
};

export const APPLICATION_FILTER_OPTIONS = {
  ALL: "All",
  MINE: "Mine",
};

export const DEFAULT_QUOTE_FILTERS = [APPLICATION_FILTER_OPTIONS.ALL, APPLICATION_FILTER_OPTIONS.MINE];

export const REPORTING_PATHS = {
  COMMISSION: "commission",
  APPLICATIONS_DATA: "applications-data",
} as const;

export const REPORTING_NAV_ITEMS = [
  {
    path: REPORTING_PATHS.APPLICATIONS_DATA,
    label: "Applications Data",
    requiresCommissionAccess: false,
    requiresOwnerOrAdminAccess: true,
  },
  {
    path: REPORTING_PATHS.COMMISSION,
    label: "Commission",
    requiresCommissionAccess: true,
    requiresOwnerOrAdminAccess: false,
  },
];

export const topbarHeight = "64px";

export const DOCUMENT_TYPES = {
  PRIVACY_AGREEMENT: "Privacy agreement",
  PRIVACY_FILE: "Privacy file",
  DISCLOSURE_STATEMENT: "Proposal Disclosure Statement",
  PPSR_CERTIFICATE: "PPSR Certificate",
  BANK_STATEMENT: "Bank statements",
  CONSENT: "consent",
  COMMERCIAL_CREDIT_FILE: "Commercial Credit File",
  ASIC_FILE: "ASIC File",
  ID_DOCUMENT: "ID document",
  ASSET_INVOICE: "Asset invoice",
  DRIVER_LICENCE_FRONT: "Driver licence (front)",
  DRIVER_LICENCE_BACK: "Driver licence (back)",
  CUSTOMER_PHOTO: "Customer photo",
  VERIFICATION_CERTIFICATE: "Verification certificate",
  CREDIT_FILE: "Credit file",
  NO_RECORD_CREDIT_FILE: "No record credit file",
  APPLICATION: "Application",
  CREDIT_SCORE: "Credit scores",
  CREDIT_FILE_BINARY: "Credit file binary",
  CUSTOMER_UPLOAD: "Customer Upload",
  FINANCIAL_STATEMENT: "Financial statement",
  COMMERCIAL_CREDIT_SCORE: "Commercial Credit Score",
  COMMERCIAL_CREDIT_REPORT: "Commercial Credit Report",
  PRELIMINARY_ASSESSMENT: "Preliminary assessment",
  EMPLOYMENT_INCOME_VERIFICATION: "Employment and income verification",
} as const;
